const styles = (theme) => ({
  container: {
    width: "100%",
    marginTop: 24,
  },
  dataGrid: {
    height: 200,
    border: `1px solid ${theme.AppBGColor}`,
    "& .ag-theme-material .ag-body-horizontal-scroll": {
      borderWidth: "0px",
    },
    [`&>.gridTheme-${theme.themeName}>.ag-theme-material.theme-${theme.themeName}`]: {
      height: "100%",
    },
    "& .statusBar": {
      display: "none",
    },
    [`& .theme-modernLight .ag-row-selected`]: {
      backgroundColor: "#edf7f7",
    },
  },
  rightHeaderControls: {},
  iconStyle: {
    color: theme.ErrorMessageColor,
    cursor: "pointer",
    fontSize: "18",
    padding: 2,
    marginLeft: 8,
  },
  refreshIconStyle: {
    color: theme.iconColor,
    cursor: "pointer",
    fontSize: "18",
    padding: 2,
    marginLeft: 8,
  },
  headerStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    border: `1px solid ${theme.AppBGColor}`,
    padding: "8px",
    borderRadius: "4px 4px 0 0",
  },
  headerLabel: {
    color: theme.HeaderSelectedText,
    fontSize: "14px",
    fontWeight: 600,
  },
});

export default styles;
